<template>
  <ProductBox 
    :product="product"
    :default-variation="defaultVariation"
    :variations="variations"
    :attributes="attributes"
  />
</template>

<script>
import ProductBox from './components/ProductBox.vue';

export default {
  name: 'App',
  components: {
    ProductBox
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    defaultVariation: {
      type: Object,
      required: false
    },
    variations: {
      type: Array,
      required: false
    },
    attributes: {
      type: Object,
      required: false
    }
  }
}
</script>
